import { getIn } from "formik";
import { ErrorDisplay } from "@ploy-lib/types";
/**
 * Builds a spread-ready object that contains the key only when the value
 * is defined. Lets callers omit a prop entirely instead of passing
 * undefined — useful whenever the receiver merges its own defaults with
 * a JSX spread (Object.assign semantics), because a key present with an
 * undefined value overrides the default, while an absent key preserves it.
 *
 * Example:
 *   <Component {...definedProp("role", role)} />
 * produces `{role: "button"}` when role is defined, and `{}` when it
 * isn't, so Component's own role default survives.
 */
export function definedProp(key, value) {
    return value !== undefined ? { [key]: value } : {};
}
export function getFormatOptions(intl, formatType, premadeFormat) {
    const optionsFromFormat = premadeFormat &&
        intl.formats[formatType] &&
        intl.formats[formatType][premadeFormat];
    if (premadeFormat && !optionsFromFormat)
        console.error(`[React Intl] No ${formatType} format named: ${premadeFormat}`);
    return optionsFromFormat;
}
export function formatToParts(formatter, value) {
    return typeof formatter.formatToParts === "function"
        ? formatter.formatToParts(value)
        : undefined;
}
export const identity = i => i;
export function defaultGetItemLabel(item) {
    return item?.["value"] ?? item;
}
export function defaultGetItemValue(item) {
    return item?.["key"] ?? item;
}
export function isNotNull(x) {
    return x != null;
}
/**
 * Generates a record type with known names
 * @param data some object object hwere all values are @type FieldEditorOptions
 */
export function identityRecordOfFieldEditorOptions(data) {
    return data;
}
export function getNoTouchError(errorDisplay) {
    switch (errorDisplay) {
        case ErrorDisplay.Touched:
        case ErrorDisplay.TouchedNoMessage:
            return ErrorDisplay.TouchedNoMessage;
        case ErrorDisplay.Always:
        case ErrorDisplay.AlwaysNoMessage:
            return ErrorDisplay.AlwaysNoMessage;
        default:
            return ErrorDisplay.Never;
    }
}
export function getFieldError(errors, touched, name, errorDisplay) {
    const errorDisplayToUse = errorDisplay ?? ErrorDisplay.Touched;
    var [displayError, displayErrorMessage] = shouldDisplayError(touched, name, errorDisplayToUse);
    if (displayError) {
        const errorMessage = errors[name] || getIn(errors, name);
        return {
            error: !!errorMessage,
            helperText: displayErrorMessage ? errorMessage : ""
        };
    }
    return {
        error: false,
        helperText: undefined
    };
}
export function shouldDisplayError(touched, name, errorDisplay) {
    switch (errorDisplay) {
        case ErrorDisplay.Touched:
            return [getIn(touched, name), true];
        case ErrorDisplay.TouchedNoMessage:
            return [getIn(touched, name), false];
        case ErrorDisplay.AlwaysNoMessage:
            return [true, false];
        case ErrorDisplay.Always:
            return [true, true];
        case ErrorDisplay.Never:
        default:
            return [false, false];
    }
}
//# sourceMappingURL=utils.js.map